<template>
    <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div data-kt-swapper="true" data-kt-swapper-mode="prepend"
            data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
            class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
            <!--begin::Title-->
            <h1 class="d-flex text-dark fw-bolder fs-3 align-items-center my-1">{{ $t(title) }}</h1>
            <!--end::Title-->
            <!--begin::Separator-->
            <span class="h-20px border-gray-300 border-start mx-4"></span>
            <!--end::Separator-->
            <!--begin::Breadcrumb-->

            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1 " v-for="(bread, key) in breadcrumbs"
                :key="key">

                <li v-if="key + 1 !== breadcrumbs.length" class="breadcrumb-item text-muted">
                    <router-link :to="bread.path" class="text-muted text-hover-primary">{{ $t(bread.name) }}</router-link>
                    <span class="bullet bg-gray-200 w-5px h-2px m-2"></span>
                </li>


                <!--end::Item-->
                <!--begin::Item-->
                <li v-else class="breadcrumb-item text-dark">{{ $t(bread.name) }}</li>
                <!--end::Item-->
            </ul>
            <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->
        <div class="d-flex align-items-center gap-2 gap-lg-3">
            <button @click="$goTo('/admin/settings-product/bundles')" class="btn btn-sm btn-flex btn-light btn-active-primary fw-bolder">
                <span class="svg-icon svg-icon-md">
                    <i class="fas fa-backspace"></i>
                </span>{{$t("back")}}
            </button>
        </div>
        <!--end::Actions-->
    </div>
</template>

<script>
export default {
    props: {
        title: { required: true, type: String, default: 'breadcrumbs.bundle.bundles' },
        breadcrumbs: { required: false, type: Array, default: [] },
    },
}
</script>
<style scoped>
#kt_menu_action{
  box-shadow: rgb(0 0 0 / 12%) 0px 1px 4px 1px;
  border-radius: 10px;
  z-index: 105;
  position: fixed;
  inset: 0px 0px auto auto;
  margin: 0px;
  transform: translate(-115px, 110px);
}
</style>